import { StringFilterDropdown } from "@/entities/string-filter-dropdown";
import { NoteTitle } from "@/common/NoteTitle";
import { DEFAULT_NOTE_TYPES, NOTE_STATUS } from "@/services/api";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import type { NotesTableRowData } from "../types/notes-table-types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";
import { getRowTextColor } from "../../lib/get-row-text-color";

export type NotesTableNoteTitleColumnProps = NotesTableColumnsProps<{
  onChangeFilter?: (value: string) => void;
  filterValue?: string;
  colorize?: boolean;
}>;

export type NotesTableNoteTitleColumnGetter =
  NotesTableColumnGetter<NotesTableNoteTitleColumnProps>;

export const getNotesTableNoteTitleColumn: NotesTableNoteTitleColumnGetter = ({
  title = "Title",
  dataIndex = ["title"],
  ellipsis = true,
  key = NOTES_TABLE_COLUMNS_KEYS.noteTitle,
  minWidth = 250,
  width = 250,
  sorter = (a: NotesTableRowData, b: NotesTableRowData) => {
    if (a.title === b.title) return 0;
    if (a.title === null) return 1;
    if (b.title === null) return -1;
    return 0;
  },
  showSorterTooltip = false,
  onChangeFilter = () => "",
  filterValue = "",
  colorize = false,
  render = (_, record) => (
    <NoteTitle
      textColor={getRowTextColor(
        record,
        colorize && DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT === record.noteType.name,
      )}
      disabled={
        record.status === NOTE_STATUS.DONE &&
        record.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT
      }
      noteTitle={record.title ?? ""}
    />
  ),
  ...props
}) => {
  const defaultFilterDropdown = (
    <StringFilterDropdown
      handleChange={(value) => onChangeFilter(value ?? "")}
      value={filterValue}
    />
  );

  return {
    title: title,
    ellipsis: ellipsis,
    dataIndex: dataIndex,
    minWidth: minWidth,
    width: width,
    key: key,
    sorter: sorter,
    filterDropdown: defaultFilterDropdown,
    render: render,
    showSorterTooltip: showSorterTooltip,
    ...props,
  };
};
